import { z } from 'zod';
import { InvoiceStatus } from '../types/index.js';
export const createInvoiceSchema = z.object({
    eventId: z.string().uuid(),
    vendorId: z.string().uuid(),
    totalAmount: z.number().positive(),
    quoteId: z.string().uuid().optional(),
    notes: z.string().max(2000).optional(),
});
export const updateInvoiceSchema = z.object({
    totalAmount: z.number().positive().optional(),
    status: z.nativeEnum(InvoiceStatus).optional(),
    notes: z.string().max(2000).optional(),
});
export const invoiceLineItemSchema = z.object({
    description: z.string().min(1).max(500),
    quantity: z.number().positive(),
    unitPrice: z.number().min(0),
    totalPrice: z.number().min(0),
    sortOrder: z.number().int().min(0),
});
//# sourceMappingURL=invoice.js.map